export default __webpack_public_path__ + "static/media/WebsiteMainPhotoBW.9383b5d6.svg";